import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Radio, Users } from "lucide-react";

/**
 * LiveNowStrip — floating pill on top of the reels feed showing currently-live streamers.
 * Polls /api/live/active every 30s. Tap the pill → navigate to /live/watch/{id}.
 * Auto-hides when no one is live.
 */
export default function LiveNowStrip() {
  const [streams, setStreams] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      api.get("/live/active").then(r => {
        if (!cancelled) setStreams(Array.isArray(r.data) ? r.data.slice(0, 8) : []);
      }).catch(() => {});
    };
    load();
    const t = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  // Rotate through visible streams every 3s if there are more than 1
  useEffect(() => {
    if (streams.length <= 1) return;
    const t = setInterval(() => setIdx(i => (i + 1) % streams.length), 3500);
    return () => clearInterval(t);
  }, [streams.length]);

  if (streams.length === 0) return null;
  const s = streams[idx] || streams[0];

  return (
    <Link
      to={`/live/watch/${s.id}`}
      data-testid="live-now-strip"
      className="fixed top-16 left-3 z-30 flex items-center gap-2 px-2.5 py-1.5 rounded-full bg-black/70 backdrop-blur-md border border-[#FF2A5F]/60 shadow-[0_0_24px_rgba(255,42,95,0.35)] active:scale-95 animate-in fade-in duration-500"
    >
      <div className="relative flex-shrink-0">
        <img src={s.user?.avatar || "https://api.dicebear.com/7.x/avataaars/svg?seed=live"} alt=""
          className="w-8 h-8 rounded-full object-cover border-2 border-[#FF2A5F]"/>
        <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-[#FF2A5F] border-2 border-black animate-pulse"/>
      </div>
      <div className="min-w-0 max-w-[140px]">
        <div className="flex items-center gap-1 text-[9px] font-black uppercase tracking-wider text-[#FF2A5F]">
          <Radio className="w-3 h-3"/> Live now
        </div>
        <div className="text-[11px] font-bold text-white truncate">{s.title || `@${s.user?.username}`}</div>
      </div>
      <div className="flex items-center gap-0.5 text-[10px] font-bold text-white/80">
        <Users className="w-3 h-3 text-[#FF7A00]"/>{s.viewers || 0}
      </div>
    </Link>
  );
}
